import { ref, getDownloadURL } from 'firebase/storage'
import { storage } from '../../config/firebase'

export class StorageService {
  /**
   * Get the download URL for a Firebase Storage path
   * @param path - The relative path in Firebase Storage (e.g., "products/uuid/uuid_FRONT")
   * @returns The full download URL that can be used in an img tag
   */
  static async getDownloadURL(path: string): Promise<string> {
    try {
      const storageRef = ref(storage, path)
      const downloadURL = await getDownloadURL(storageRef)
      return downloadURL
    } catch (error) {
      console.error(`Failed to get download URL for path: ${path}`, error)
      throw error
    }
  }

  /**
   * Get download URLs for multiple paths
   * @param paths - Array of relative paths in Firebase Storage
   * @returns Array of download URLs
   */
  static async getMultipleDownloadURLs(paths: string[]): Promise<(string | null)[]> {
    const promises = paths.map(async (path) => {
      try {
        return await StorageService.getDownloadURL(path)
      } catch (error) {
        console.error(`Failed to get download URL for path: ${path}`, error)
        return null
      }
    })
    
    return Promise.all(promises)
  }
}